let colorA = 'rgb(248, 142, 83)';
let colorB = 'rgb(253, 190, 112)';
let colorC = 'rgb(72, 155, 179)';
let colorD = 'rgb(95, 181, 171)';

let tall = 300;
let short = 50;
let reallyShort = 16;
let reallySkinny = 100;

export const configs = {
	'episodeGrid': {
		displayName: "Average IMDB Ratings by Episode",
		shape: {},
		x: { name:'rating', min:4, max:10 },
	},
	'largeLineRatings': {
		shape: { height:tall },
		x: { name:'id' },
		y: { name:'rating', min:4, max:10 },
		color1: colorA,
		color2: colorB,
		legend: true,
		strokeWidth: 5,
		gridlineOpacity: .2,
		isInline: false,
		tooltip: true
	},
	'smallLineRatings': {
		shape: { height:short },
		x: { name:'id', round:false },
		y: { name:'rating', min:4, max:10 },
		color1: colorA,
		color2: colorB,
		legend: false,
		strokeWidth: 1,
		gridlineOpacity: .1,
		isInline: false,
		margins: [0, 0, 0, 0]
	},
	'sparklineRatings': {
		shape: { height:reallyShort, width:reallySkinny },
		x: { name:'id' },
		y: { name:'rating', min:7, max:11 },
		color1: colorA,
		color2: colorB,
		legend: false,
		strokeWidth: 1,
		gridlineOpacity: 0,
		isInline: true,
		margins: [0, 0, 0, 0]
	},
	'sparklineRatingsDexter': {
		shape: { height:reallyShort, width: 100 },
		x: { name:'id' },
		y: { name:'rating', min:6, max:10 },
		color1: colorA,
		color2: colorB,
		legend: false,
		strokeWidth: 1,
		gridlineOpacity: 0,
		isInline: true,
		margins: [0, 0, 0, 0]
	},
	'largeLineViewers': {
		shape: { height:tall },
		x: { name:'id' },
		y: { name:'viewers', min:0 , max:14 },
		color1: colorC,
		color2: colorD,
		legend: true,
		strokeWidth: 5,
		gridlineOpacity: .2,
		isInline: false,
		tooltip: true
	},
	'smallLineViewers': {
		shape: { height:short },
		x: { name:'id' },
		y: { name:'viewers', min:0 },
		color1: colorC,
		color2: colorD,
		legend: false,
		strokeWidth: 1,
		gridlineOpacity: .1,
		isInline: false,
		margins: [0, 0, 0, 0]
	},
	'sparklineViewers': {
		shape: { height:reallyShort, width:reallySkinny },
		x: { name:'id' },
		y: { name:'viewers' },
		color1: colorC,
		color2: colorD,
		legend: false,
		strokeWidth: 1,
		gridlineOpacity: 0,
		isInline: true,
		margins: [0, 0, 0, 0]
	},
	'compareLineViewers': {
		shape: { height:tall },
		x: { name:'id' },
		y: { name:'viewers', min:0 , max: 80 },
		color1: colorC,
		color2: colorD,
		legend: true,
		strokeWidth: 5,
		gridlineOpacity: .2,
		isInline: false,
		margins: [0, 0, 0, 0],
	},
	'largeBubble': {
		shape: { height:tall },
		x: { name:'viewers' },
		y: { name:'rating', min:4, max:10 },
		r: { name:'id', min:1 },
		legend: true,
		minBubbleSize: 2,
		maxBubbleSize: 10,
		gridlineOpacity: .2,
	},
	'sparklineBubble': {
		shape: { height:reallyShort, width:reallySkinny },
		x: { name:'viewers' },
		y: { name:'rating' },
		r: { name:'id', min:1 },
		legend: false,
		minBubbleSize: 1,
		maxBubbleSize: 2,
		gridlineOpacity: .1,
		isInline: true,
		margins: [0, 0, 0, 0]
	},
	'doubleLine': {
		shape: { height:tall },
		x: { name:'id' },
		y: { name:'rating', min:4, max:10 },
		y2: {name: 'viewers', min:0},
		color1: colorA,
		color2: colorB,
		color3: colorC,
		color4: colorD,
		legend: true,
		strokeWidth: 3,
		gridlineOpacity: .2,
		isInline: false,
		tooltip: true
	},
}